<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{ error: NuxtError }>()

const isNotFound = computed(() => props.error.statusCode === 404)
const heading = computed(() => (isNotFound.value ? 'PAD EMPTY' : 'VOICE STOLEN'))
const body = computed(() =>
  isNotFound.value
    ? "Nothing's assigned to this pad — the page you're looking for doesn't exist or moved."
    : props.error.statusMessage || 'Something went wrong loading this page.'
)

function goHome() {
  clearError({ redirect: '/' })
}
</script>

<template>
  <NuxtLayout>
    <div class="mx-auto flex max-w-[640px] flex-col items-center py-14 text-center">
      <div class="screen-frame w-full">
        <div class="screen px-6 py-12">
          <div class="font-mono text-xs uppercase tracking-[0.18em] text-phosphor/55">
            Err {{ error.statusCode || 500 }}
          </div>
          <div class="mt-3 font-screen text-6xl leading-none tracking-wide text-phosphor max-[520px]:text-5xl">
            {{ heading }}
          </div>
          <p class="mx-auto mt-4 max-w-[46ch] font-sans text-sm leading-relaxed text-phosphor/55">
            {{ body }}
          </p>
        </div>
      </div>
      <div class="mt-7 flex gap-3">
        <button
          type="button"
          class="rounded px-5 py-2.5 font-mono text-xs font-medium uppercase tracking-wide text-[#1a0f04] bg-accent hover:opacity-90"
          @click="goHome"
        >
          Back to the hub
        </button>
        <NuxtLink
          to="/player/"
          class="rounded border border-border px-5 py-2.5 font-mono text-xs uppercase tracking-wide text-muted hover:border-accent-dim hover:text-ink"
          @click="clearError()"
        >
          Open the Player
        </NuxtLink>
      </div>
    </div>
  </NuxtLayout>
</template>
